import React, { useEffect, useState } from 'react';
import { Helmet } from 'react-helmet-async';
import { Parallax } from "react-parallax";
import { Link, useNavigate } from "react-router-dom";
import Navbar from '../layout/Navbar';
import Preloader from '../layout/preloader';
import Footer from '../section-pages/footer';
import ScrollToTopBtn from '../layout/ScrollToTop';
import { createGlobalStyle } from 'styled-components';
import { handleRegister } from '../api';
import { AppContext, siteName } from "../main";

const image1 = "./img/background/5.webp";

const GlobalStyles = createGlobalStyle`
  .react-parallax-bgimage {
    transform: translate3d(-50%, 0, 0px) !important;
  }
`;

export default function Home(props) {
    const navigate = useNavigate();
    const [data, setData] = useState({});
    const [errors, setErrors] = useState({});
    const [loading, setLoading] = useState(false);



    useEffect(() => {
        if (typeof window !== 'undefined') {
            const loader = document.getElementById('mainpreloader');
            if (loader)
                setTimeout(() => {
                    loader.classList.add("fadeOut");
                    loader.style.display = 'none';
                }, 600);
        }
    }, []);

    const validateForm = () => {
        const newErrors = {};

        if (!data.name || data.name.trim() === '') {
            newErrors.name = "Name is required.";
        }

        if (!data.email || !/\S+@\S+\.\S+/.test(data.email)) {
            newErrors.email = "Valid email is required.";
        }

        if (!data.handle || data.handle.trim().length < 3) {
            newErrors.handle = "Username must be at least 3 characters.";
        }

        if (!data.password || data.password.length < 6) {
            newErrors.password = "Password must be at least 6 characters.";
        }

        if (data.password !== data["re-password"]) {
            newErrors["re-password"] = "Passwords do not match.";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        setLoading(true)
        e.preventDefault();
        if (validateForm()) {
            // console.log('cccc', data)
            data['resource'] = `vare_user_${siteName}`
            delete data?.['re-password']
            await handleRegister(data).then(ref => {
                alert("Form submitted successfully!");
                setLoading(false)
                navigate("/login");
            })
            // Submit logic here
        }
    };


    return (
        <>
            <Helmet>
                <link rel="icon" href="./img/icon.png" />
                <title>HCCC Digital - Game Host</title>
            </Helmet>

            <GlobalStyles />

            <div id='mainpreloader'>
                <Preloader />
            </div>

            <div className="home dark-scheme">
                <header id="header-wrap">
                    <Navbar />
                </header>

                <Parallax className="" bgImage={image1} strength={5}>
                    <div className="de-gradient-edge-top"></div>
                    <div className="de-gradient-edge-bottom"></div>
                    <section className="no-bg">
                        <div className="container z-9 mt100">
                            <div className="row align-items-center">
                                <div className="col-lg-8 offset-lg-2">
                                    <div className="p-5 rounded-10 shadow-soft bg-dark-1" id="login">
                                        <form name="contactForm" id='contact_form' className="form-border" onSubmit={handleSubmit}>
                                            <h4>Don&apos;t have an account? Register now.</h4>
                                            <p>Welcome to Plahost. We&apos;re excited to have you on board.</p>
                                            <div className="row">

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Name:</label>
                                                        <input
                                                            type='text'
                                                            name='name'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, name: e.target.value, fullName: e.target.value })}
                                                        />
                                                        {errors.name && <small className="text-danger">{errors.name}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Email Address:</label>
                                                        <input
                                                            type='text'
                                                            name='email'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, email: e.target.value })}
                                                        />
                                                        {errors.email && <small className="text-danger">{errors.email}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Choose a Username:</label>
                                                        <input
                                                            type='text'
                                                            name='username'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, handle: e.target.value })}
                                                        />
                                                        {errors.handle && <small className="text-danger">{errors.handle}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Phone:</label>
                                                        <input
                                                            type='text'
                                                            name='phone'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, phone: e.target.value })}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Password:</label>
                                                        <input
                                                            type='password'
                                                            name='password'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, password: e.target.value })}
                                                        />
                                                        {errors.password && <small className="text-danger">{errors.password}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-md-6">
                                                    <div className="field-set">
                                                        <label>Re-enter Password:</label>
                                                        <input
                                                            type='password'
                                                            name='re-password'
                                                            className="form-control"
                                                            onChange={e => setData({ ...data, "re-password": e.target.value })}
                                                        />
                                                        {errors["re-password"] && <small className="text-danger">{errors["re-password"]}</small>}
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 offset-lg-3 text-center my-3">
                                                    <div id='submit'>
                                                        <input
                                                            type='submit'
                                                            id='send_message'
                                                            value={loading ? "Loading..." : 'Register Now'}
                                                            className="btn-main color-2"
                                                            disabled={loading}
                                                        />
                                                    </div>
                                                </div>

                                                <div className="col-lg-6 offset-lg-3">
                                                    <div className="title-line">Or&nbsp;sign&nbsp;up&nbsp;with</div>
                                                    <div className="row g-2">
                                                        <div className="col-lg-6">
                                                            <Link className="btn-sc btn-fullwidth mb10" to="/"><img src="./img/svg/google_icon.svg" alt="" />Google</Link>
                                                        </div>
                                                        <div className="col-lg-6">
                                                            <Link className="btn-sc btn-fullwidth mb10" to="/"><img src="./img/svg/facebook_icon.svg" alt="" />Facebook</Link>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </Parallax>

                <Footer />
            </div>
            <ScrollToTopBtn />
        </>
    );
}
